var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApps2Line = function SvgApps2Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.875 9.625a3.375 3.375 0 1 1 0-6.75 3.375 3.375 0 0 1 0 6.75m.375 7.5a3.375 3.375 0 1 1 0-6.75 3.375 3.375 0 0 1 0 6.75m7.5-7.5a3.375 3.375 0 1 1 0-6.75 3.375 3.375 0 0 1 0 6.75m0 7.5a3.375 3.375 0 1 1 0-6.75 3.375 3.375 0 0 1 0 6.75m-7.875-9a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75m.375 7.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75m7.5-7.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75m0 7.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75"
  })));
};
export default SvgApps2Line;